import { gql } from "@apollo/client"

export const CHILD_CREATE = gql`mutation CreateChild ($input: ChildInput!) {
  createChild (child: $input) {
  lastname,
  firstname,
  birth_date
  }
}`
